import { render, staticRenderFns } from "./PopupContentText.vue?vue&type=template&id=660b9fb6"
import script from "./PopupContentText.vue?vue&type=script&lang=js"
export * from "./PopupContentText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports